// | ------------------------------------------------------------------------
// | Main Navigation
// | ------------------------------------------------------------------------

import { Tab } from "bootstrap";

// | ------------------------------------------------------------------------

window.addEventListener("load", (event) => {
  // Set variables
  var body = document.querySelector("body");
  var nav = document.querySelector(".main-nav");
  var button = document.querySelector("#mobile-nav-btn");
  var windowWidth = document.body.clientWidth;

  // Toggle menu function
  var toggleDrawer = function () {
    body.classList.toggle("mobile-nav-open");
    button.classList.toggle("toggled");
    document.documentElement.classList.toggle("no-scroll");
  };

  if (nav) {
    // Open/close drawer using menu button
    button.addEventListener(
      "click",
      function (event) {
        event.stopPropagation();
        toggleDrawer();
      },
      false
    );

    // Prevent menu closing when clicked
    nav.addEventListener(
      "click",
      function (event) {
        event.stopPropagation();
      },
      false
    );

    // Close drawer when clicking off menu
    body.addEventListener(
      "click",
      function () {
        if (body.classList.contains("mobile-nav-open")) {
          toggleDrawer();
        }
      },
      false
    );

    // Close drawer if window is resized
    window.addEventListener("resize", function () {
      if (document.body.clientWidth !== windowWidth) {
        if (body.classList.contains("mobile-nav-open")) {
          toggleDrawer();
        }
      }
      windowWidth = document.body.clientWidth;
    });
  }
});

// Get tabs in dropdowns to work on hover

document.addEventListener("DOMContentLoaded", function () {
  function closeTabs() {
    // Close all tab panes
    var tabPanes = document.querySelectorAll(".nav-prod-pane");
    tabPanes.forEach(function (tab) {
      tab.classList.remove("active");
    });
  }

  document.querySelectorAll(".nav-prod-tabs a").forEach(function (navItem) {
    // Open relevant tab when mouse enters
    navItem.addEventListener("mouseenter", function () {
      var tabTrigger = new Tab(navItem);
      tabTrigger.show();
    });

    // Close tab when mouse leaves
    navItem.addEventListener("mouseleave", function () {
      closeTabs();

      // Remove stuff from tab link
      navItem.classList.remove("active");
      navItem.setAttribute("aria-selected", "false");
    });

    // Click takes you to the relevant page
    navItem.addEventListener("click", function () {
      var navUrl = navItem.getAttribute("href");
      console.log(navUrl);
      window.location.href = navUrl;
    });
  });

  document.querySelectorAll(".nav-prod-pane").forEach(function (tabPane) {
    // Keep tab open when mouse enters
    tabPane.addEventListener("mouseenter", function () {
      var tabId = tabPane.getAttribute("id");
      var tabLink = document.getElementById(tabId + "-tab");

      var tabTrigger = new Tab(tabLink);
      tabTrigger.show();
    });

    // Close tab when mouse leaves
    tabPane.addEventListener("mouseleave", function () {
      closeTabs();

      var tabId = tabPane.getAttribute("id");
      var tabLink = document.getElementById(tabId + "-tab");

      // Remove stuff from tab link
      tabLink.classList.remove("active");
      tabLink.setAttribute("aria-selected", "false");
    });
  });
});

// Allow root page links on desktops

window.addEventListener("load", (event) => {
  // Check if .main-nav is on the page first
  var mainNav = document.querySelector(".main-nav");

  if (mainNav) {
    // If so find the dropdown links
    var dropdownLinks = document.querySelectorAll(
      ".main-nav .nav-link.dropdown-toggle"
    );

    var tabLinks = document.querySelectorAll(".dd-tab-link")

    // Change link attributes depending on screen size
    function changeDropdownLinks(mediaQuery) {
      if (mediaQuery.matches) {
        for (const dropDownLink of dropdownLinks) {
          dropDownLink.removeAttribute("data-bs-toggle");
          dropDownLink.setAttribute("data-bs-hover", "");
        }  
        for (const tabLink of tabLinks) {

          if(tabLink.hasAttribute("data-bs-toggle")){

          }else{
            var toggleAtt = tabLink.getAttribute("disabled-data-bs-toggle");
            var targetAtt = tabLink.getAttribute("disabled-data-bs-target");
            tabLink.setAttribute("data-bs-toggle", toggleAtt);
            tabLink.setAttribute("data-bs-target", targetAtt); 
            tabLink.removeAttribute("disabled-data-bs-toggle");
            tabLink.removeAttribute("disabled-data-bs-target");                       
          }
        }             
      } else {
        for (const dropDownLink of dropdownLinks) {
          dropDownLink.removeAttribute("data-bs-hover");
          dropDownLink.setAttribute("data-bs-toggle", "dropdown");
        }
        for (const tabLink of tabLinks) {
          var toggleAtt = tabLink.getAttribute("data-bs-toggle");
          var targetAtt = tabLink.getAttribute("data-bs-target");
          tabLink.setAttribute("disabled-data-bs-toggle", toggleAtt);
          tabLink.setAttribute("disabled-data-bs-target", targetAtt);
          tabLink.removeAttribute("data-bs-toggle");
          tabLink.removeAttribute("data-bs-target");
        } 
      }
    }

    // Create a MediaQueryList object
    var mediaQuery = window.matchMedia("(min-width: 768px)");

    // Call listener function at run time
    changeDropdownLinks(mediaQuery);

    // Attach listener function on state changes
    mediaQuery.addEventListener("change", function () {
      changeDropdownLinks(mediaQuery);
    });
  }
});
